var _path, _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgCustomRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 114H129.5C147 114 154 107 154 89.5V68.5C154 51 147 44 129.5 44H108.5C91 44 84 51 84 68.5V89.5C84 107 91 114 108.5 114Z",
    fill: "url(#paint0_linear_227_24467)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_227_24467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint1_linear_227_24467)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_227_24467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint2_linear_227_24467)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    stroke: "url(#paint3_linear_227_24467)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_227_24467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3035 108.017C84.3681 105.509 86.8536 103.75 89.75 103.75H100.25C103.146 103.75 105.632 105.509 106.696 108.017M102 90.625C102 94.491 98.866 97.625 95 97.625C91.134 97.625 88 94.491 88 90.625C88 86.759 91.134 83.625 95 83.625C98.866 83.625 102 86.759 102 90.625ZM112.5 95C112.5 104.665 104.665 112.5 95 112.5C85.335 112.5 77.5 104.665 77.5 95C77.5 85.335 85.335 77.5 95 77.5C104.665 77.5 112.5 85.335 112.5 95Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_227_24467",
    x: 0,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_227_24467"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_227_24467",
    x: 43.25,
    y: 43.25,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_227_24467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_227_24467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_227_24467",
    x: 76,
    y: 76,
    width: 38,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_227_24467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_227_24467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_24467",
    x1: 89,
    y1: 51,
    x2: 142,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_227_24467",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_227_24467",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC47D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_227_24467",
    x1: 123,
    y1: 66,
    x2: 66,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCustomRoles);
export default __webpack_public_path__ + "static/media/ImgCustomRoles.3f4a31d953caee1c81576d068db2b192.svg";
export { ForwardRef as ReactComponent };